export default __webpack_public_path__ + "static/media/dmeh-logo.50192e9d.jpg";